export default __webpack_public_path__ + "static/media/185w.86a533af.svg";